import { queryOptions, useQuery } from '@tanstack/react-query';
import { getTeacherProfile } from '@/app/(teacher)/profile/_actions/getTeacherProfile';
import type { TeacherProfileWithRelations } from '@/app/(teacher)/profile/_actions/types';
import type { ServerActionResponse } from '@/features/server/actions/types';
import { useAuth } from './useAuth';

export const TeacherProfileQuery = queryOptions({
  queryKey: ['teacherProfile'],
  queryFn: getTeacherProfile,
  select: (resp: ServerActionResponse<TeacherProfileWithRelations | null>) => resp.data,
});

export default function useTeacherProfile() {
  const { isSignedIn } = useAuth();

  return useQuery({
    ...TeacherProfileQuery,
    enabled: isSignedIn,
  });
}
